import { CloseIcon } from "components/ui/icons/uploadbar/CloseIcon"
import { ChevronLeftIcon } from "./icons/ChevronLeftIcon"
import { ChevronRightIcon } from "./icons/ChevronRightIcon"
import { ReturnIcon } from "./icons/ReturnIcon"
import style from "./JumpingNavigationBar.module.scss"

const { bar, left, center, right, button, title, counter, backButton, backIcon, closeButton, iconButton } = style

type Props = {
	title: string
	currentIndex: number
	total: number
	onBack: () => void
	onPrev: () => void
	onNext: () => void
	onClose: () => void
}

export const JumpingNavigationBar = ({
	title: titleText,
	currentIndex,
	total,
	onBack,
	onPrev,
	onNext,
	onClose,
}: Props) => {
	const prevDisabled = currentIndex <= 0
	const nextDisabled = currentIndex >= total - 1

	return (
		<div className={bar} role="toolbar" aria-label="Jumping navigation">
			<div className={left}>
				<button type="button" className={`${button} ${backButton}`} onClick={onBack} aria-label="Back to object">
					<span className={backIcon} aria-hidden="true">
						<ReturnIcon />
					</span>
					<span className={title}>{titleText}</span>
				</button>
			</div>
			<div className={center}>
				<button
					type="button"
					className={`${button} ${iconButton}`}
					onClick={onPrev}
					disabled={prevDisabled}
					aria-label="Previous callout"
				>
					<ChevronLeftIcon />
				</button>
				<span className={counter}>
					{currentIndex + 1} / {total}
				</span>
				<button
					type="button"
					className={`${button} ${iconButton}`}
					onClick={onNext}
					disabled={nextDisabled}
					aria-label="Next callout"
				>
					<ChevronRightIcon />
				</button>
			</div>
			<div className={right}>
				<button type="button" className={`${button} ${closeButton}`} onClick={onClose} aria-label="Close jumping bar">
					<CloseIcon />
				</button>
			</div>
		</div>
	)
}
